module.exports = __webpack_public_path__ + "static/media/2nd.bc22e75a.jpg";